import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import frenchMessages from "ra-language-french";
import ptBrMessages from "ra-language-pt-br";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { raSupabaseFrenchMessages } from "ra-supabase-language-french";
import { englishCrmMessages } from "./englishCrmMessages";
import { frenchCrmMessages } from "./frenchCrmMessages";
import { ptBrCrmMessages } from "./ptBrCrmMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
  },
};

const raSupabaseFrenchMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Consultez vos emails pour trouver le message de reinitialisation du mot de passe.",
    },
  },
};

const raSupabasePtBrMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset:
        "Verifique seu e-mail para encontrar a mensagem de redefinição de senha.",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

const frenchCatalog = mergeTranslations(
  englishCatalog,
  frenchMessages,
  raSupabaseFrenchMessages,
  raSupabaseFrenchMessagesOverride,
  frenchCrmMessages,
);

// Catálogo pt-BR (FaroMarket): inicia do englishCatalog (fallback p/ chaves não traduzidas),
// sobrepõe com ra-language-pt-br + override Supabase + traduções específicas do Atomic CRM.
const ptBrCatalog = mergeTranslations(
  englishCatalog,
  ptBrMessages,
  raSupabasePtBrMessagesOverride,
  ptBrCrmMessages,
);

export const getInitialLocale = (): "en" | "fr" | "pt-BR" => {
  // FaroMarket: pt-BR é a default operacional (regra de idioma do Mazoir, 2026-05-09).
  // Mantém detecção via navegador como fallback educado para devs/usuários não-BR.
  if (typeof navigator === "undefined") {
    return "pt-BR";
  }

  const browserLocale = navigator.languages?.[0] ?? navigator.language;
  const locale = browserLocale?.toLowerCase() ?? "";

  if (locale.startsWith("pt")) {
    return "pt-BR";
  }
  if (locale.startsWith("fr")) {
    return "fr";
  }
  if (locale.startsWith("en")) {
    return "en";
  }

  return "pt-BR";
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale === "fr") {
      return frenchCatalog;
    }
    if (locale === "pt-BR") {
      return ptBrCatalog;
    }
    return englishCatalog;
  },
  getInitialLocale(),
  [
    { locale: "pt-BR", name: "Português (Brasil)" },
    { locale: "en", name: "English" },
    { locale: "fr", name: "Français" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => ptBrCatalog,
  "pt-BR",
  [{ locale: "pt-BR", name: "Português (Brasil)" }],
  { allowMissing: true },
);
